import { Link } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";

const AuthShell = ({ children, testId }) => (
  <main className="min-h-screen flex flex-col items-center justify-center px-4 py-16" data-testid={testId}>
    <Link to="/" className="font-display gold-text text-3xl mb-2">Earth Angel</Link>
    <p className="eyebrow mb-8">Owner sign in</p>
    {children}
  </main>
);

export const SignInPage = () => (
  <AuthShell testId="sign-in-page">
    <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
  </AuthShell>
);

export const SignUpPage = () => (
  <AuthShell testId="sign-up-page">
    <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
  </AuthShell>
);
